module.exports = __webpack_public_path__ + "media/Video 156.dce522d4.mp4";